import { render } from "./totalPieEcharts.vue?vue&type=template&id=5a5277c4&scoped=true"
import script from "./totalPieEcharts.vue?vue&type=script&lang=js"
export * from "./totalPieEcharts.vue?vue&type=script&lang=js"

import "./totalPieEcharts.vue?vue&type=style&index=0&id=5a5277c4&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5277c4"]])

export default __exports__